import { GenIcon } from 'react-icons';
export const MdCurrencyFlagUnknown = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'circle',
            attr: {
                cx: '12',
                cy: '12',
                r: '11.5',
                fill: '#E0E0E0',
                stroke: '#BDBDBD',
            },
            child: [],
        },
    ],
});
